import { render, staticRenderFns } from "./ExampleCustomBuiltInListItem.vue?vue&type=template&id=148a8b7a&"
import script from "./ExampleCustomBuiltInListItem.vue?vue&type=script&lang=ts&"
export * from "./ExampleCustomBuiltInListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports